import TemplateView from "../../../TemplateView";
import {PERMISSION_ICON_CLASS} from "../../../permissions/constants";
import messageResource from '../../../messageResource'

export default class PermissionRow extends TemplateView
{
    constructor($containerEl, permissionId, permissionResources)
    {
        super($containerEl);
        this.id = permissionId;

        this.state = {
            checked: false,
            disabled: false,
            lastRow: false,
            name: permissionResources.name,
        }

        this.onStatePropertyChanged('checked', (checked) => {
            this.$el.toggleClass('active', checked);
            this.$el.toggleClass('inactive', !checked);
            this.icon.toggleClass('inactive', !checked);
        });

        this.onStatePropertyChanged('disabled', (disabled) => {
            this.$el.toggleClass('disabled', disabled);
        });
        this.onStatePropertyChanged('lastRow', (lastRow) => {
            this.$el.toggleClass('lastRow', lastRow);
        });

        this.onStatePropertyChanged('name', (name) => {
            this.$name.text(name)
        })
    }


    templateHtml()
    {
        return "<div class='userPanel_permissionRow'>" +
               "    <div class='checkbox'><div class='img'/></div>" +
               "    <div class='icon <%-iconClass%>'/>" +
               "    <div class='name'></div>" +
               "</div>";
    }

    templateModel() {
        return {
            iconClass: PERMISSION_ICON_CLASS[this.id]
        }
    }

    afterRender()
    {
        this.icon = this.find('.icon');
        this.bindClick(() =>
                       {
                           if (!this.state.disabled)
                           {
                               this.trigger('changed', [this.id, !this.state.checked]);
                           }
                       })

        this.$name = this.find('.name')

        this.renderInitialState()
    }

    update()
    {
        this.$el.toggleClass('active', this.state.checked);
        this.$el.toggleClass('inactive', !this.state.checked);
        this.icon.toggleClass('inactive', !this.state.checked);
    }

    toggle(needToDisplay)
    {
        this.$el.toggle(needToDisplay);
    }

    getId() {
        return this.id
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/PermissionRow.js